import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import Navigation from "./Navigation.jsx";
import Hero from "./Hero.jsx";
import Offer from "./Offer.jsx";
import AboutUs from "./AboutUs.jsx";
import Services from "./Services.jsx";
import Work from "./Work.jsx";
import Price from "./Price.jsx";
import Gallery from "./Gallery.jsx";
import FAQ from "./FAQ.jsx";
import Contact from "./Contact.jsx";
import Footer from "./Footer.jsx";

function Vulcanization() {

  // useEffect(() => {
  //   console.log("Public Key:", process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  // }, []);


  return (
    <div>
      <Navigation />
      <Hero />
      <Offer />
      <AboutUs />
      <Services />
      <Work />
      <Price />
      <Gallery />
      <FAQ />
      <Contact />
      {/* <CookieBanner />
      <CookieSettings
      settings={cookieSettings}
      setSettings={setCookieSettings}/>
      <CookiesPolicy />
      <PrivacyPolicy /> */}
      <Footer />
    </div>
  );
}

export default Vulcanization;
